//import React from 'react'
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";
import { uploads } from "../config";

import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Home = () => {

    const [category, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${API_URL}/api-select-all-category.php`)
            .then(res => res.json())
            .then(data => setUsers(data))
            .catch(err => console.log(err));
    }, []);

    // ✅ SEARCHING 
    const handleSearch = (e) => {
        e.preventDefault();

        if (!search.trim()) return;

        navigate(`/search?search=${encodeURIComponent(search)}`);
    };

    return (
        <div>
            <div className='banner-panel'>
                <div className='txt-box'>Find What You Need in BagahaBazaar</div>
                <div className='txt-box1'>Find local Shops, Services, Professionals and more in just a few clicks.</div>
                <form onSubmit={handleSearch}>
                    <div className='search-box d-flex'>
                        <div className='text-field'><input type="text" className='inputbox' placeholder="Enter your name" value={search} onChange={(e) => setSearch(e.target.value)} /></div>
                        <div className='button-box'><button type="submit" className='search-btn'><SearchOutlinedIcon />Search</button></div>
                    </div>
                </form>
            </div>
            <section>
                <div className='service-panel'>
                    <div className='heading'>
                        Business Category
                        <div className='sub-heading'>Doctors, gyms, and fitness services at your doorstep</div>
                    </div>
                    <div className='blisting'>

                        {category.map(cat => (
                            <div className='listbox' key={cat.id}>
                                <Link to={`/${cat.menu_url}`} className='list-nav'>
                                    <div className='icon-box'><img src={`${uploads}/${cat.menu_img}`} className='fullimg' alt='agriculture' /></div>
                                    <div className='title'>{cat.menu_name}</div>
                                </Link>
                            </div>
                        ))}

                        <div className='listbox' style={{ display: "none" }}>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='clr'></div>
                    </div>
                    <div className="viewmore-box"><Link to="/" className='viewmore-btn'>View More <ArrowForwardIcon /></Link></div>
                </div>
            </section>
            <section style={{ display: "none" }}>
                <div className='service-panel service-bg'>
                    <div className='heading white'>
                        By Professional Services
                        <div className='sub-heading white'>Doctors, gyms, and fitness services at your doorstep</div>
                    </div>
                    <div className='blisting'>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox1'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='clr'></div>
                    </div>
                    <div className="viewmore-box"><Link to="/" className='viewmore-btn'>View More <ArrowForwardIcon /></Link></div>
                </div>
            </section>
            <section style={{ display: "none" }}>
                <div className='popular-services'>
                    <div className='heading'>
                        Popular Services
                        <div className='sub-heading'>Doctors, gyms, and fitness services at your doorstep</div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <fieldset className="custom-fieldset">
                                <legend>Beauty Parlour & Spa</legend>
                                <div className='blisting'>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/fieldset-img1.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Beauty Parlours</div>
                                        </Link>
                                    </div>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/spa.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Spa & Massages</div>
                                        </Link>
                                    </div>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/salons.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Salons</div>
                                        </Link>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div className='col-md-6'>
                            <fieldset className="custom-fieldset">
                                <legend>Beauty Parlour & Spa</legend>
                                <div className='blisting'>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/fieldset-img1.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Beauty Parlours</div>
                                        </Link>
                                    </div>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/spa.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Spa & Massages</div>
                                        </Link>
                                    </div>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/salons.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Salons</div>
                                        </Link>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div className='col-md-6'>
                            <fieldset className="custom-fieldset">
                                <legend>Beauty Parlour & Spa</legend>
                                <div className='blisting'>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/fieldset-img1.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Beauty Parlours</div>
                                        </Link>
                                    </div>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/spa.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Spa & Massages</div>
                                        </Link>
                                    </div>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/salons.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Salons</div>
                                        </Link>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div className='col-md-6'>
                            <fieldset className="custom-fieldset">
                                <legend>Beauty Parlour & Spa</legend>
                                <div className='blisting'>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/fieldset-img1.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Beauty Parlours</div>
                                        </Link>
                                    </div>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/spa.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Spa & Massages</div>
                                        </Link>
                                    </div>
                                    <div className='listbox'>
                                        <Link to="/" className='list-nav'>
                                            <div className='icon-box'><img src='images/salons.jpg' className='fullimg' alt='agriculture' /></div>
                                            <div className='title'>Salons</div>
                                        </Link>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home
